<!--
 * @Author: Tang Hao
 * @Date: 2025-12-22 14:00:17
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-22 15:34:38
 * @Description:
-->
<template>
  <div>
    <el-input @click.native="openModal" :disabled="disabled" v-model="value.redPoolAccountName" placeholder="请选择红包池" />
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'Payment',
  props: {
    value: {
      type: Object,
      default: () => ({ redPoolAccountName: '', redPoolAccountCode: '' }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectConfig,
  },
  watch: {},
  data() {
    return {};
  },

  methods: {
    // 打开弹窗
    openModal() {
      if (this.disabled) {
        return;
      }
      const params = {
        functionCode: 'select_redpacket_pool',
        idKey: 'materialGroupCode',
        paramData: {},
        noReset: true,
        data: this.value && this.value.redPoolAccountCode ? [this.value.redPoolAccountCode] : [],
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 选择产品回调
    onGetSelect(val) {
      if (val.length > 0) {
        const data = {
          redPoolAccountName: val[0].poolAccountName,
          redPoolAccountCode: val[0].poolAccountCode,
        };
        this.$emit('input', data);
        this.$emit('change', data);
      } else {
        this.$message.warning('请选择红包池');
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
